































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Cover, SyText } from './DetailComponents';
import SyPlayer from '@/components/XGplayer.vue';
import VoteButton from '@/components/VoteButton/index.vue';
import { detailModel } from '@/api/api';
@Component({
  components: {
    Cover,
    SyText,
    VoteButton,
    SyPlayer,
  },
})
export default class SyDetail extends Vue {
  @Prop({ default: 'left' }) type!: string;
  @Prop({ default: 1 }) id!: number;
  mockDetail: any[] = [
    {
      showType: 1,
      value:
        'http://image.cqrb.cn/d/file/image/WrCrQJBM9QCuIwJHlfj19AVQEdBqPFSe0jTWK35j.png',
    },
    { showType: 2, value: '这里全是标题很多很多标题' },
    { showType: 4, value: '点赞数: 999' },
    { showType: 3, value: '点赞按钮' },
    {
      showType: 5,
      value:
        '详情介绍：重庆两江新区第一人民医院呼吸与危重医学科是以呼吸道慢病及常见病、呼吸危重症、呼吸介入及呼吸康复治疗为主，集临床、教学、科研为一体的综合性科室，开放病床80张，设有呼吸重症抢救室、气管镜室、肺功能及过敏原诊断室、睡眠呼吸诊疗室，常年开设有呼吸慢病门诊、哮喘门诊、戒烟门诊及咳嗽门诊，年收治病人3500人次/年，门诊量35000人次/年左右。',
    },
  ];
  detailData: any[] = [];
  async created() {
    const res: any = await detailModel('2020project/2020shortvideo', this.id);
    console.log(res);
    if (res && res.code === 200) {
      this.detailData = res.data;
    }
  }
}
